export function isAsyncLike(obj) {
  return typeof obj === 'object' && obj.then && typeof obj.then === 'function';
}
export function isAsync(obj) {
  return obj != null && (obj instanceof Promise || isAsyncLike(obj));
}
export function toAsyncBoolean() {
  const results = [];
  for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputs[_key] = arguments[_key];
  }
  inputs.forEach(arg => {
    if (Array.isArray(arg)) {
      results.push(...arg);
    } else {
      results.push(arg);
    }
  });
  const hasAsync = results.some(res => isAsync(res));
  if (hasAsync) {
    const deferres = results.map(res => isAsync(res) ? res : Promise.resolve(res !== false));
    return Promise.all(deferres).then(arr => arr.reduce((memo, item) => item !== false && memo, true));
  }
  return results.every(res => res !== false);
}
export function toDeferredBoolean() {
  for (var _len2 = arguments.length, inputs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    inputs[_key2] = arguments[_key2];
  }
  const ret = toAsyncBoolean(inputs);
  return typeof ret === 'boolean' ? Promise.resolve(ret) : ret;
}